import Input from "./Input";
import { useState } from "react";
import Result from "./Result";
import { Routes, Route, Navigate } from "react-router";
import Profile from "./components/Profile";
import Dashboard from "./components/Dashboard";

function Main() {
    return <Routes>
        <Route path="/" element={<Input />}></Route>
        <Route path="/result/:uuid" element={<Result />} />
        <Route path="/profile/" element={<Profile />} />
        <Route path="/dashboard/" element={<Dashboard />} />
    </Routes> 
}

export default Main;